import React from 'react';
import style from "./style.scss";

const TextArea = ({ value, classN = "", placeholder = "", handleChange }) => {
    return (
        <textarea
            className={classN}
            placeholder={placeholder}
            onChange={(e) => handleChange(e.target.value)}>
            {value}
        </textarea>
    )
}

export default TextArea